import { render, staticRenderFns } from "./ShipmentsBrowse.vue?vue&type=template&id=79a64010&scoped=true"
import script from "./ShipmentsBrowse.vue?vue&type=script&lang=js"
export * from "./ShipmentsBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a64010",
  null
  
)

export default component.exports